import { Action } from "@ngrx/store";
import { IDevice, IDeviceOptOut } from "@edp-models/device.model";

export enum ENotificationsActions {
    SendOptOut = "[Notifications] Sending opt-out state",
    SaveOptOut = "[Notifications] Saving opt-out state",
    GetOptOut = "[Notifications] Getting opt-out state",
    RegisterDevice = "[Notifications] Registering device",
    SaveDevice = "[Notifications] Saving device",
    GetPushConfigs = "[Notifications] Get Push Configurations",
    SetPushConfigs = "[Notifications] Set Push Configurations",
    UpdatePushConfigs = "[Notifications] Update Push Configurations"
}

export class SendOptOut implements Action {
    public readonly type = ENotificationsActions.SendOptOut;
    constructor(public payload: IDeviceOptOut) {}
}

export class SaveOptOut implements Action {
    public readonly type = ENotificationsActions.SaveOptOut;
    constructor(public payload: boolean) {}
}

export class GetOptOut implements Action {
    public readonly type = ENotificationsActions.GetOptOut;
    constructor(public payload: IDeviceOptOut) {}
}

export class RegisterDevice implements Action {
    public readonly type = ENotificationsActions.RegisterDevice;
    constructor(public payload: IDevice) {}
}

export class SaveDevice implements Action {
    public readonly type = ENotificationsActions.SaveDevice;
    constructor(public payload: IDevice) {}
}

export class GetPushConfigs implements Action {
    public readonly type = ENotificationsActions.GetPushConfigs;
}

export class SetPushConfigs implements Action {
    public readonly type = ENotificationsActions.SetPushConfigs;
    constructor(public payload: any) {}
}

export class UpdatePushConfigs implements Action {
    public readonly type = ENotificationsActions.UpdatePushConfigs;
    constructor(public payload: any) {}
}

export type NotificationsActions = SendOptOut
    | SaveOptOut
    | GetOptOut
    | RegisterDevice
    | SaveDevice
    | GetPushConfigs
    | SetPushConfigs
    | UpdatePushConfigs;
